import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, Alert, FormGroup} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone,} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {searchDownload, searchList} from "../../store/search/actions";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
import ViewerModal from "../../components/Common/ViewerModal";
import SmallAvatar from "../../components/Common/SmallAvatar";

class FJSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filesData: this.props.responseList ? this.props.responseList.response : [],
      loadingList: false,
      errorList: "",
      viewerModal: false,
      searchText: this.props.searchText,
    }

    this.togViewerModal = this.togViewerModal.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        filesData: this.props.responseList ? this.props.responseList.response : [],
        loadingList: this.props.loadingList,
        errorList: this.props.errorList,
        searchText: this.props.searchText,
      });
    }
  }

  togViewerModal(data = null) {
    this.setState(prevState => ({
      viewerData: data,
      viewerModal: !prevState.viewerModal,
    }))
  }

  render() {
    const uploaderFormatter = (cell, row) => {
      return (<div>
        <SmallAvatar user={row.uploader} history={this.props.history}/>
      </div>);
    }

    const actionFormatter = (cell, row) => {
      return (<div>
        <a className="bx bx-download font-size-20" title="Download" onClick={() => (this.props.onSearchDownload({sign: row.sign, filename: row.name, history: this.props.history}))}></a>
        <a className="bx bx-detail font-size-20" title="View" onClick={() => this.togViewerModal({sign: row.sign, name: row.name})}></a>
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "sign", text: "Sign",
    }, {
      dataField: "name", text: "Name", sort: true,
    }, {
      dataField: "section", text: "Section", sort: true,
    }, {
      dataField: "segment", text: "Segment", sort: true,
    }, {
      dataField: "year", text: "Year", sort: true,
    }, {
      dataField: "month", text: "Month", sort: true,
    }, {
      dataField: "uploader", text: "Uploader", sort: true, formatter: uploaderFormatter,
    }, {
      dataField: "created", text: "Created", sort: true,
    }, {
      dataField: "", text: "Actions", formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "desc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.filesData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText) || row.sign.toLowerCase().includes(searchText) || row.section.toLowerCase().includes(searchText)
        || row.segment.toLowerCase().includes(searchText) || row.year.toLowerCase().includes(searchText) || row.month.toLowerCase().includes(searchText)
        || row.uploader.toLowerCase().includes(searchText) || row.created.includes(searchText))
        return true
      return false
    }

    document.title = "Search | FileJet";

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={this.props.t("FileJet")}
            breadcrumbItem={this.props.t("Search")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.filesData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.filesData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="4">
                            <Formik
                              initialValues={{
                                search: this.state.searchText,
                              }}
                              validationSchema={Yup.object().shape({
                                search: Yup.string().min(3, "Search string is too short").max(32, "Search string is too long").required("Search cannot be empty"),
                              })}
                              onSubmit={values => {
                                this.props.onSearchList({data: {text: values.search}, history: this.props.history})
                              }}
                            >
                              {({errors, status, touched}) => (<Form>
                                <FormGroup>
                                  <Field
                                    id="search"
                                    name="search"
                                    placeholder="Search"
                                    type="text"
                                    className={"form-control" + (errors.search && touched.search ? " is-invalid" : "")}
                                  />
                                  <ErrorMessage
                                    name="search"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Form>)}
                            </Formik>
                          </Col>
                          <Col md="4">
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loadingList && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.errorList.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.errorList}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.viewerModal && <ViewerModal togModal={this.togViewerModal} viewerData={this.state.viewerData} history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

FJSearch.propTypes = {
  responseList: PropTypes.any,
  onSearchList: PropTypes.func,
  onSearchDownload: PropTypes.func,
};

const mapStateToProps = ({Search}) => ({
  responseList: Search.responseList,
  loadingList: Search.loadingList,
  errorList: Search.errorList,
  searchText: Search.searchText,
});

const mapDispatchToProps = dispatch => ({
  onSearchList: data => dispatch(searchList(data)),
  onSearchDownload: data => dispatch(searchDownload(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FJSearch));
